export const media_by = {
    gallery: "Галерэя",
    photo: "Фота"
}